import React,{useEffect, useState}  from 'react';
import FinanceNewsLayout from "../../components/layout/mainNmycorp/FinanceNewsLayout";
import IndustryNewsLayout from "../../components/layout/mainNmycorp/IndustryNewsLayout";
import ThemeNewsLayout from "../../components/layout/mainNmycorp/ThemeNewsLayout";
import MycorpList from "../../components/layout/mainNmycorp/MycorpList";
import MycorpLogin from "../../components/layout/mainNmycorp/MycorpLogin";
import MycorpNewsList from "../../components/layout/mainNmycorp/MycorpNewsList";
import {getMycorpAPI} from "../../apis/my_service";
import {getRealtimeNewsAPI} from "../../apis/news_service";
import NewsList from "../../components/common/NewsList";
import moment from "moment";


const MyCorpPage = () => {
    const isLogin = localStorage.getItem('access_token');
    const today = moment().format('YYYY년 MM월 DD일');

    const [corpList, setCorpList] = useState([])//마이종목 목록
    const [isTotal, setIsTotal] = useState(true) //마이기업 전체 카드 클릭 여부
    const [targetCode, setTargetCode] = useState('') // 클릭된 마이종목코드
    const [targetStockname, setTargetStockname] = useState('') // 클릭된 마이종목코드

    const [newslist, setNewslist] = useState([])

    const getMyCorpData = () => {
        getMycorpAPI().then(res => {
            if(res !== null){
                setCorpList(res)
            }
        })
    }

    useEffect(getMyCorpData, [])

    useEffect(()=> {
        const params = {
            signal: '긍정',
            ordertpye: 'asc'

        }
        getRealtimeNewsAPI(params).then(res => setNewslist(res))
    },[])

    const myCorpClick = (code,name) => {
        setIsTotal(code === 'total')
        setTargetCode(code)
        setTargetStockname(name)
    }

    return (
        <div className='mycorp'>
            {!!isLogin && isTotal && corpList.length > 0 &&
                <div className='head_img_my container'>
                    <div className='inner_container' style={{display:'flex', justifyContent:'space-between'}}>
                        <p className='head_title'>마이 기업 뉴스 <span>금융시장 뉴스 / 산업 뉴스 / 테마 뉴스</span></p>
                        <p className='head_date'>{today}</p>
                    </div>
                </div>


            }

            {/*로그인 했을 때 마이기업 목록 UI , 안했을 때 로그인 안내 UI*/}
            {!!isLogin ?
                <MycorpList myCorpClick={myCorpClick} corpList={corpList} count={corpList.length}/>
                : <MycorpLogin/>
            }

            {/*마이기업 목록이 있고, 전체 카드 클릭 시 전체 화면 , 그 외 클릭 기업 관련 뉴스*/}
            { !!isLogin ?
                isTotal && corpList.length > 0?
                    <>
                        <FinanceNewsLayout />
                        <div  className='inner_container divider_black' />
                        <IndustryNewsLayout/>
                        <ThemeNewsLayout />
                    </>
                    :
                    <div className='inner_container mycorp_newslist'>
                        {corpList.length === 0 &&
                            <div className='inner_container mycorp_surprise'>
                                <p className='title_md newslist_title gutterbottom'>서프라이즈 뉴스 확인하기</p>
                                <NewsList newsList={newslist} type='vertical' size='5' main=''/>
                            </div>}
                        {corpList.length > 0 && <MycorpNewsList targetStockname={targetStockname} targetCode={targetCode}/>}
                    </div>
                :
                <div className='inner_container mycorp_surprise'>
                    <p className='title_md newslist_title gutterbottom'>서프라이즈 뉴스 확인하기</p>
                    <NewsList newsList={newslist} type='vertical' size='5' main=''/>
                </div>
            }
        </div>
    );
};

export default MyCorpPage;